import React, { useEffect, useMemo, useRef, useState } from "react";
import Slider from "react-slick";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useIsInViewport, useWindowSize } from "../../../hooks";
import {
  baseLogoCarouselSettings,
  getLogoCarouselSlidesToShow,
} from "../logoCarouselSettings";
import "./AboutUs.scss";
import { Image } from "../../common/image/Image";

const ArrowStyles = {
  color: "#F9DF1C",
  fontSize: "5rem",
};

const NextArrow = ({ className, onClick }) => (
  <ArrowForwardIosIcon
    className={className}
    sx={{ ...ArrowStyles, transform: "translate(3rem, -50%)" }}
    onClick={onClick}
  />
);

const PrevArrow = ({ className, onClick }) => (
  <ArrowBackIosNewIcon
    className={className}
    sx={{ ...ArrowStyles, transform: "translate(-3rem, -50%)" }}
    onClick={onClick}
  />
);

const AboutUs = ({ title, featuredIn }) => {
  const windowSize = useWindowSize();
  const isInViewportThreshold = windowSize.width > 768 ? 0.5 : 0.2;
  const sectionRef = useRef(null);
  const sliderRef = useRef(null);
  const isInViewport = useIsInViewport(sectionRef, isInViewportThreshold);
  const [showAnimation, setShowAnimation] = useState(false);
  const maxItemsToShow = Math.min(6, featuredIn?.length || 0);
  const settings = useMemo(
    () => ({
      ...baseLogoCarouselSettings,
      slidesToShow: Math.min(
        getLogoCarouselSlidesToShow(windowSize.width, maxItemsToShow),
        maxItemsToShow || 1
      ),
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
    }),
    [windowSize.width, maxItemsToShow]
  );

  useEffect(() => {
    if (isInViewport) {
      setShowAnimation(isInViewport);
    }
  }, [isInViewport]);

  useEffect(() => {
    if (showAnimation && sliderRef.current?.innerSlider) {
      sliderRef.current.innerSlider.onWindowResized();
    }
  }, [showAnimation, windowSize.width, settings.slidesToShow]);

  return (
    <section
      className={`section section--aboutUs${showAnimation ? " onScreen" : ""}`}
      ref={sectionRef}
    >
      <div className="section__innerWrapper">
        <article className="overDeco">
          <h3 className="center animateIn">{title}</h3>
        </article>
        <Slider ref={sliderRef} {...settings}>
          {featuredIn?.map((feat, index) => (
            <div className="slide-wrapper" key={feat.id || index}>
              <Image
                src={`${process.env.REACT_APP_IMG_URL || ""}/${feat.img}`}
                alt="Featured"
                onClick={() => window.open(feat.link)}
              />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default AboutUs;
